(ns machtfit.startpage.scrolling
  (:require [re-frame.core :as rf]
            [reagent.core :as r]))

(defn- scroll-frame! [{:keys [subject
                              mode
                              margin-bottom
                              margin-top
                              frame]}]
  (when-let [stepchall-frame (.querySelector js/document "#sc_app-frame-inner")]
    (let [[scroll-frame
           frame-offset
           view-top
           view-height] (if (= frame :app-frame)
                          [stepchall-frame
                           (.-offsetHeight (or (.querySelector js/document ".sc_header") 0))
                           (.-scrollTop stepchall-frame)
                           (.-offsetHeight stepchall-frame)]
                          [js/window
                           0
                           (.-scrollY js/window)
                           (.-innerHeight js/window)])
          subject-element (.querySelector js/document subject)
          subject-top (if subject-element (- (.-offsetTop subject-element) margin-top) 0)
          subject-height (if subject-element (+ (.-offsetHeight subject-element) margin-bottom margin-top) 0)
          subject-bottom (+ subject-top subject-height)
          new-y (case mode
                  :fully-visible (let [subject-top-not-in-view? (< subject-top (+ view-top frame-offset))
                                       subject-bottom-not-in-view? (> subject-bottom (+ view-top view-height))]
                                   (cond
                                     subject-top-not-in-view? (- subject-top frame-offset)
                                     subject-bottom-not-in-view? (- subject-bottom view-height)))
                  :top (- subject-top frame-offset)
                  :center (- (+ subject-top (/ subject-height 2)) (/ view-height 2))
                  :page-top 0
                  nil)]
      (when new-y (.scrollTo scroll-frame 0 new-y)))))

(defn- scroll! [scroll-to]
  (when (= (:frame scroll-to) :app-frame)
    (scroll-frame! {:mode :fully-visible :subject "#sc_app-frame"}))
  (scroll-frame! scroll-to))

(rf/reg-fx :scroll-to
  (fn [scroll-to]
    (r/after-render #(scroll! scroll-to))))

(rf/reg-fx ::scroll-to-position
  (fn [{:keys [position smooth?]}]
    (r/after-render
     #(.scrollTo js/window (if smooth?
                             #js {:top position :behavior "smooth"}
                             #js {:top position})))))

(rf/reg-event-fx ::to-page-top
  (fn [_ [_ {:keys [smooth?]}]]
    {::scroll-to-position {:position 0 :smooth? smooth?}}))
